import { render } from "./StemAlert.vue?vue&type=template&id=07e7c70a&scoped=true"
import script from "./StemAlert.vue?vue&type=script&lang=js"
export * from "./StemAlert.vue?vue&type=script&lang=js"

import "./StemAlert.vue?vue&type=style&index=0&id=07e7c70a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e7c70a"]])

export default __exports__